module.exports = __webpack_public_path__ + "static/media/info.d45fd9d4.svg";